import { CopilotConversation, PromptResponseCitation } from 'models/copilot/copilotConversation';
import { TenantProcessStatus } from 'models/copilot/tenantProcessStateBase';
import Task from 'models/tasks/task';

// Mirror of ProcessStateSupplierIncidents.SupplierIncidentsStage (isoplanner-api, PLAN-073)
export enum SupplierIncidentsStage {
  Investigating = 0,
  Summary = 1,
  Preview = 2,
  Saved = 3,
}

// One incident, breach or outage the research found, with its sources; selected says whether it becomes an incident
// task, alreadyRegisteredTaskId names the register's own incident task that already covers it
export class SupplierIncidentFinding {
  date?: Date;

  kind: string = '';

  title: string = '';

  summary: string = '';

  citations: PromptResponseCitation[] = [];

  selected: boolean = false;

  alreadyRegisteredTaskId?: number;
}

// The incidents investigation of one Supplier asset as an AI process (PLAN-073), mirror of
// ProcessStateSupplierIncidents: the findings, the card's choices, the concept incident tasks and the created tasks
export class TenantProcessStateSupplierIncidents {
  status: TenantProcessStatus = TenantProcessStatus.NotStarted;

  assetId: number = 0;

  assetName: string = '';

  stage: SupplierIncidentsStage = SupplierIncidentsStage.Investigating;

  findings: SupplierIncidentFinding[] = [];

  summaryMarkdown?: string;

  // the task templates carrying an Incident label, in the order the card offers them
  eligibleTemplateIds: number[] = [];

  defaultTemplateId?: number;

  allowedTagIds: number[] = [];

  incidentTagId?: number;

  ownerId?: string;

  // the concept incident tasks of the preview; nothing exists before the save
  newTasks: Task[] = [];

  createdTaskIds: number[] = [];

  conversation: CopilotConversation = new CopilotConversation();
}
